
(function () {
  'use strict';

  const REFRESH_EVENT = "cart:refresh";

  // --- Fire refresh event ---
  function triggerCartRefresh() {
    document.dispatchEvent(new CustomEvent(REFRESH_EVENT));
    console.log("[CartDrawer] Fired", REFRESH_EVENT);
  }

  // --- Intercept fetch (for AJAX /cart/add) ---
  if (window.fetch) {
    const origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      return origFetch(input, init).then(response => {
        try {
          const url = typeof input === "string" ? input : input.url;
          if (url && url.includes("/cart/add") && response.ok) {
            setTimeout(triggerCartRefresh, 150);
          }
        } catch (e) { }
        return response;
      });
    };
  }

  // --- Intercept XHR (for older themes) ---
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return origOpen.apply(this, arguments);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener("load", function () {
      if (this._url && this._url.includes("/cart/add") && this.status >= 200 && this.status < 400) {
        setTimeout(triggerCartRefresh, 150);
      }
    });
    return origSend.apply(this, arguments);
  };
})();

// -------------------------------
// Variant switcher + price update
// -------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const inputs = document.querySelectorAll("input[name='product_choice']");
  const atcBtn = document.getElementById("rv-add-to-cart");
  const mainPriceEl = document.querySelector("#iEexEcZW3FkwdebQd");
  const discount_value = document.getElementById("discount_value");
  const discount_percent = document.getElementById("discount_percent");
  const rv_original_price = document.getElementById("rv_original_price");

  let selectedVariantId = null;
  let selectedPrice = null;
  let updating = false;
  let initialSetupDone = false;
  let restoreTimer;

  if (inputs.length && atcBtn && mainPriceEl) {
    inputs.forEach(input => {
      input.addEventListener("change", function () {
        handleSelection(this, true);
      });
    });

    const observer = new MutationObserver(() => {
      if (selectedVariantId && !updating) {
        updating = true;
        if (selectedPrice) updatePrice(selectedPrice);
        updateATC(selectedVariantId);
        setTimeout(() => { updating = false }, 100);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.requestAnimationFrame(() => {
      const checkedInput = document.querySelector("input[name='product_choice']:checked");
      if (checkedInput && !initialSetupDone) {
        handleSelection(checkedInput, false);
        initialSetupDone = true;
      }
    });
  }

  function handleSelection(input, userTriggered) {
    selectedVariantId = input.value;
    selectedPrice = input.dataset.price;
    const discount_value = document.getElementById("discount_value");
    const discount_percent = document.getElementById("discount_percent");

    let new_discount_value = input.dataset.discount_value;
    let new_discount_percent = input.dataset.discount_percent;
    let new_rv_original_price = input.dataset.rv_original_price;
    
    if(discount_value != null)
    discount_value.innerText =new_discount_value;
    
    if(new_discount_percent  != null)
    discount_percent.innerText =new_discount_percent+"%";


    rv_original_price.innerText =new_rv_original_price;
    /*console.log(discount_percent);
    console.log("RV Debug → Active option:", {
      variantId: selectedVariantId,
      price: selectedPrice,
      userTriggered
    });*/

    document.querySelectorAll(".rv-option-card").forEach(card => {
      card.classList.remove("active");
    });
    const parentCard = input.closest(".rv-option-card");
    if (parentCard) parentCard.classList.add("active");

    updatePrice(selectedPrice);

    updateATC(selectedVariantId, userTriggered);
  }

  function updateATC(variantId, userTriggered = true) {
    if (!atcBtn) return;
    atcBtn.setAttribute("href", `/cart/${variantId}:1`);
    atcBtn.setAttribute("data-instant-action-variant-id", variantId);
   
    if (userTriggered) atcBtn.dataset.rvManualChange = "true";
  }

  function updatePrice(price) {
    if (!mainPriceEl) return;
    clearTimeout(restoreTimer);
    mainPriceEl.textContent = price;
    const currentPrice = price;
    restoreTimer = setTimeout(() => {
      const newText = mainPriceEl.textContent;
      if (newText !== currentPrice) {
        console.log("Restored overridden price:", newText, "→", currentPrice);
        mainPriceEl.textContent = currentPrice;
      }
    }, 300);
  }
});

// -------------------------------
// Swiper carousel
// -------------------------------
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rv-video-carousel').forEach((carousel) => {
    new Swiper(carousel, {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 15,
      navigation: {
        nextEl: carousel.querySelector('.swiper-button-next'),
        prevEl: carousel.querySelector('.swiper-button-prev'),
      },
      pagination: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
  });
});

// -------------------------------
// Add-on product popup + Preorder logic
// -------------------------------
document.addEventListener('DOMContentLoaded', () => {
  const addToCartBtn = document.getElementById('rv-add-to-cart');
  console.log('acd');
  if (!addToCartBtn) return;

  const popup = document.querySelector('#addon-popup');
  const addonYes = document.querySelector('#addon-yes');
  const addonNo = document.querySelector('#addon-no');

  const openCartDrawer = () => {
    document.querySelector('.cart-drawer-pull-rv')?.click();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  const addToCart = (variantId, qty = 1, isPreorder = false) => {
    const body = { id: variantId, quantity: qty, properties: {} };
    if (isPreorder) {
      body.properties = { _preorder: true, DeliveryType: 'Preorder' };
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(res => res.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        setTimeout(openCartDrawer, 150);
      });
  };

  // handle Add to Cart click
  addToCartBtn.addEventListener('click', (e) => {
   
    const hasPreorder = addToCartBtn.dataset.hasPreorder === 'true';
    const hasAddon = addToCartBtn.dataset.hasAddon === 'true';

    // if neither preorder nor addon applies, let default behavior happen
    if (!hasPreorder && !hasAddon) return;

    e.preventDefault();
    e.stopPropagation();

    const selectedOption = document.querySelector('input[name="product_choice"]:checked');
    if (!selectedOption) {
      alert('Select delivery option first');
      return;
    }

    const selectedVariantId = selectedOption.value;
    const isPreorder = selectedOption.id === 'opt-preorder';
    const addonVariantId = addToCartBtn.dataset.addonVariantId;

    if (hasAddon && popup) {
      popup.style.display = 'flex';
      popup.dataset.mainVariant = selectedVariantId;
      popup.dataset.addonVariant = addonVariantId || '';
      popup.dataset.isPreorder = isPreorder ? 'true' : 'false';
    } else {
      addToCart(selectedVariantId, 1, isPreorder);
    }
  });

  addonYes?.addEventListener('click', async (e) => {
    e.preventDefault(); e.stopPropagation();
    const mainId = popup.dataset.mainVariant;
    const addonId = popup.dataset.addonVariant;
    const isPreorder = popup.dataset.isPreorder === 'true';
    popup.style.display = 'none';
    await addToCart(mainId, 1, isPreorder);
    if (addonId) await addToCart(addonId);
  });

  addonNo?.addEventListener('click', async (e) => {
    e.preventDefault(); e.stopPropagation();
    const mainId = popup.dataset.mainVariant;
    const isPreorder = popup.dataset.isPreorder === 'true';
    popup.style.display = 'none';
    await addToCart(mainId, 1, isPreorder);
  });

  popup?.addEventListener('click', (e) => {
    if (e.target === popup) popup.style.display = 'none';
  });
});
